import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SchedulePage from "../pages/schedule/page";
import SpeakersPage from "../pages/speakers/page";
import RegisterPage from "../pages/register/page";
import PremiumPage from "../pages/premium/page";
import PaymentPage from "../pages/payment/page";
import PaymentSuccessPage from "../pages/payment-success/page";
import UpgradePage from "@/pages/upgrade/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/schedule",
    element: <SchedulePage />,
  },
  {
    path: "/speakers",
    element: <SpeakersPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/premium",
    element: <PremiumPage />,
  },
  {
    path: "/payment",
    element: <PaymentPage />,
  },
  {
    path: "/payment-success",
    element: <PaymentSuccessPage />,
  },
  {
    path: "/upgrade/:token",
    element: <UpgradePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
